import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";

/**
 * RoleSidebar
 * Listagem lateral dos cargos utilizando o componente padronizado NeoSideMenu.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const RoleSidebar = ({ roles = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar cargos baseado na pesquisa local
    const filteredRoles = roles.filter((role) =>
        role.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear cargos para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredRoles.map((role) => ({
        id: role.id,
        label: role.name,
        description: role.description || "Sem descrição",
        icon: "mdi-account-cog",
        badge: role.status === 'inactive' ? "Inativo" : null,
        badgeVariant: role.status === 'inactive' ? "muted" : null
    }));

    return (
        <NeoSideMenu
            title="Cargos"
            subtitle="Permissões e acessos"
            icon="mdi-account-cog"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const role = roles.find((r) => r.id === id);
                if (role) onSelect(role);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar cargo..."
                />
            }
        />
    );
};

RoleSidebar.propTypes = {
    roles: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default RoleSidebar;
